<template>
  <div class="b-no-results">
    <i class="icon-sad"></i>
    <span>
      {{ dictionary.noResultsFound }}
    </span>
    <slot></slot>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue'
const { dictionary } = getCurrentInstance().appContext.config.globalProperties
</script>
